import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

import Header from '../components/Header';

import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';

const Wishlist = () => {
  const { wishlist } = useCart();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50">
      <Header />

      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-5 sm:py-8">

        <h1 className="text-xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-8">
          My Wishlist
        </h1>

        {wishlist.length === 0 ? (
          <div className="text-center py-10">
            <div className="text-4xl mb-2">❤️</div>
            <h2 className="text-lg sm:text-2xl font-bold text-gray-800 mb-1">
              Your wishlist is empty
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              Save your favorite products here!
            </p>
            <button
              onClick={() => navigate('/store')}
              className="px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:shadow-md transition-all text-sm"
            >
              Browse Products
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-6">
            {wishlist.map(product => (
              <ProductCard
                key={product._id}
                product={product}
              />
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Wishlist;
